import { IAlias } from '@common/interfaces/bbc'
import { ICapTableSummaryData } from '@common/interfaces/capTable'
import {
  IEntityInfo,
  IEntityReportStatsData,
  IEntityDilutionData,
  IEntityActivityData,
  IEntityMergeConflicts,
  ICustomerAggregation,
  IVendorAggregation,
  IEntityCollateralAggregation,
  IInvestorAggregation,
  IEntityAccountsData,
} from '@common/interfaces/entityInfo'
import { combineReducers } from 'redux'
import { loadingArrayReducer } from '../../helpers/helpers'
import { createLoadingDataReducer } from '../../helpers/redux'
import { IAction } from '../apiMiddleware'
import * as actions from './actions'

export default combineReducers({
  loadingArray: loadingArrayReducer(
    [actions.prefix],
    [
      actions.GET_CUSTOMER_AGGREGATION_REQUEST,
      actions.GET_ENTITY_ACTIVITY_REQUEST,
      actions.GET_ENTITY_DILUTION_REQUEST,
      actions.GET_ENTITY_AR_SUMMARY_REQUEST,
      actions.GET_ENTITY_AR_DETAILS_REQUEST,
      actions.GET_ENTITY_AP_SUMMARY_REQUEST,
      actions.GET_ENTITY_AP_DETAILS_REQUEST,
      actions.GET_ENTITY_DUPLICATE_ENTITIES_REQUEST,
      actions.GET_INVESTMENT_ROW_DETAIL_REQUEST,
    ],
  ),
  entities(state: IEntityInfo[] = [], action: IAction<IEntityInfo[]>): IEntityInfo[] {
    switch (action.type) {
      case actions.LIST_ENTITY_INFO_SUCCESS:
        return action.data

      default:
        return state
    }
  },
  entity(state: IEntityInfo = null, action: IAction): IEntityInfo {
    switch (action.type) {
      case actions.GET_ENTITY_INFO_SUCCESS:
        return action.data as IEntityInfo
      case actions.GET_ENTITY_DUPLICATE_ENTITIES_SUCCESS: {
        const data = action.data as Pick<IEntityInfo, 'entitiesWithDuplicates'>
        return {
          ...state,
          entitiesWithDuplicates: data.entitiesWithDuplicates,
        }
      }
      case actions.UPDATE_ENTITY_INFO_SUCCESS:
      case actions.UPDATE_DUPLICATE_ENTITY_SUCCESS: {
        const data = action.data as { data: IEntityInfo }
        if (state?.id === data.data.id) {
          return {
            ...state,
            ...data.data,
          }
        }
        return state
      }

      case actions.ADD_ENTITY_RELATIONSHIP_SUCCESS: {
        const data = action.data as { parent: IEntityInfo; subsidiary: IEntityInfo }
        if (data.parent.id === state.id) {
          return {
            ...state,
            subsidiaries: [...state.subsidiaries, data.subsidiary],
          }
        }
        if (data.subsidiary.id === state.id) {
          return {
            ...state,
            parent: data.parent,
          }
        }
        return state
      }

      case actions.DELETE_ENTITY_RELATIONSHIP_SUCCESS: {
        const data = action.data as { parent: IEntityInfo; subsidiary: IEntityInfo }
        if (data.parent.id === state.id) {
          return {
            ...state,
            subsidiaries: state.subsidiaries.filter(
              (subsidiary) => subsidiary.id !== data.subsidiary.id,
            ),
          }
        }
        if (data.subsidiary.id === state.id) {
          return {
            ...state,
            parent: null,
          }
        }
        return state
      }
      case actions.HIDE_ENTITY_INFO:
        return null
      default:
        return state
    }
  },
  entityMergeConflicts(
    state: IEntityMergeConflicts[] = [],
    action: IAction<IEntityMergeConflicts[]> & {
      error?: { code?: string; data?: IEntityMergeConflicts[] }
    },
  ): IEntityMergeConflicts[] {
    switch (action.type) {
      case actions.UPDATE_ENTITY_INFO_FAILURE:
        if (action.error.code === 'CUSTOM_ERROR') {
          return action.error.data
        }
        return state
      case actions.GET_ENTITY_INFO_SUCCESS:
        return []
      default:
        return state
    }
  },
  entityArSummary: createLoadingDataReducer<IEntityReportStatsData>([
    actions.GET_ENTITY_AR_SUMMARY_REQUEST,
    actions.GET_ENTITY_AR_DETAILS_REQUEST,
  ]),
  entityApSummary: createLoadingDataReducer<IEntityReportStatsData>([
    actions.GET_ENTITY_AP_SUMMARY_REQUEST,
    actions.GET_ENTITY_AP_DETAILS_REQUEST,
  ]),
  entityDilution: createLoadingDataReducer<IEntityDilutionData>([
    actions.GET_ENTITY_DILUTION_REQUEST,
  ]),
  entityActivity: createLoadingDataReducer<IEntityActivityData>([
    actions.GET_ENTITY_ACTIVITY_REQUEST,
  ]),
  aliases: createLoadingDataReducer<{ data: IAlias[] }>(
    [actions.GET_ALIASES_REQUEST, actions.LIST_ALIAS_REQUEST],
    [],
    false,
    [actions.HIDE_ALIASES],
  ),
  customersAggregation: createLoadingDataReducer<ICustomerAggregation>([
    actions.GET_CUSTOMER_AGGREGATION_REQUEST,
  ]),
  vendorsAggregation: createLoadingDataReducer<IVendorAggregation>([
    actions.GET_VENDOR_AGGREGATION_REQUEST,
  ]),
  entityAr: createLoadingDataReducer<IEntityCollateralAggregation>(
    [actions.LIST_ENTITY_AR_REQUEST],
    [actions.UPDATE_ENTITY_AR_REQUEST],
  ),
  entityAp: createLoadingDataReducer<IEntityCollateralAggregation>(
    [actions.LIST_ENTITY_AP_REQUEST],
    [actions.UPDATE_ENTITY_AP_REQUEST],
  ),
  investorAggregation: createLoadingDataReducer<IInvestorAggregation>([
    actions.LIST_INVESTORS_REQUEST,
  ]),
  investmentSummary: createLoadingDataReducer<ICapTableSummaryData>([
    actions.LIST_SUMMARY_INVESTORS_REQUEST,
    actions.GET_INVESTMENT_ROW_DETAIL_REQUEST,
  ]),
  entityAccounts: createLoadingDataReducer<IEntityAccountsData>(
    [actions.LIST_ENTITY_ACCOUNTS_REQUEST],
    [actions.UPDATE_ENTITY_ACCOUNTS_REQUEST],
    false,
    [actions.HIDE_ENTITY_ACCOUNTS],
  ),
})
